import {Component, Input, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {FinancialChartAccount} from '../../_models/financial-account.model';
import {
    ColumnFilter,
    DataTableColumnData, DatatableComponent,
    DataTableConfig, DataTableDataSource, DataTableObservableCompletionListener,
    DataTableObservableDataSource, DataTableObservableErrorListener, DataTableObservableRefresher, TableAction
} from '@cas-hub/acabim-common-client';
import {FinancialChartService} from '../../_services/financial-chart.service';
import {map} from 'rxjs/operators';
import {MessageService, PrimeNGConfig} from 'primeng/api';

@Component({
    selector: 'acabim-admin-financial-datatable',
    templateUrl: './financial-datatable.component.html',
    styleUrls: ['./financial-datatable.component.scss'],
    providers: [MessageService]
})
export class FinancialDatatableComponent implements OnInit {
    public dataSources: DataTableDataSource<any>[] = [];
    @Input() currentIndex = 0;
    @Input() classId = 0;
    @Input() classes: any[] = [];
    @ViewChild('dataTable') public dataTable?: DatatableComponent;
    showAddModal = false;
    modalTitle = ' ';
    details = null;

    // tslint:disable-next-line:use-lifecycle-interface
    ngOnChanges(changes: SimpleChanges) {
        this.dataTable?.requestImmediateDataRefresh();
    }

    constructor(private readonly financialService: FinancialChartService, private messageService: MessageService,
                private primengConfig: PrimeNGConfig) {
    }

    ngOnInit(): void {
        this.primengConfig.ripple = true;
        this.dataSources.push(new AccountDS(this.dataRefresher(this.currentIndex), undefined, undefined, action => {
        }));
        this.details = this.dataSources[0].detailData;
    }

    private dataRefresher(currentSource: number): DataTableObservableRefresher<FinancialChartAccount> {
        return () =>
            this.financialService.getAllClasses(false, true).pipe(map(data => {
                data[currentSource].accounts.forEach(acc => {
                    acc.status = acc.status === 1 ? 'active' : 'inactive';
                });
                return data[currentSource].accounts;
            }));
    }

    toggleStatus($event: boolean) {

        if ($event) {
            if (this.dataSources[0].detailData) {
                this.modalTitle = 'Edit Account';
            } else {
                this.modalTitle = 'Add Account';
            }
        } else {
            this.dataSources[0].detailData = undefined;
        }
        this.showAddModal = $event;

    }

    closeModal($event: string) {
        this.toggleStatus(false);
        this.dataTable?.requestImmediateDataRefresh();
        this.messageService.clear();
        this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: $event
        });
    }
}

export class AccountDS<T extends FinancialChartAccount> extends DataTableObservableDataSource<T> {

    readonly columnData: DataTableColumnData[] =
        [
            {displayName: 'Code', objectPropertyName: 'full_identifier', colWidth: '4rem', textAlign: 'center'},
            {displayName: 'Name', objectPropertyName: 'name', colWidth: '16rem', textAlign: 'left'},
            {displayName: 'Description', objectPropertyName: 'description'},
            {displayName: 'Account Type', objectPropertyName: 'account_type', colWidth: '6rem', textAlign: 'left'},
            {displayName: 'Value Type', objectPropertyName: 'value_type', colWidth: '6rem', textAlign: 'left'},
            {displayName: 'Status', objectPropertyName: 'status', colWidth: '6rem', textAlign: 'center'},
        ];
    config: DataTableConfig;
    columnFilters: ColumnFilter[] = [];
    actions: TableAction[] = [];

    onDataExpanded(value: FinancialChartAccount): void {
    }

    constructor(readonly dataRefresher: DataTableObservableRefresher<T>,
                readonly observableErrorListener?: DataTableObservableErrorListener,
                readonly observableCompleteListener?: DataTableObservableCompletionListener,
                readonly actionListener?: (action: TableAction) => void) {
        super(() => this.dataRefresher(),
            undefined, undefined);

        this.config = {
            tableHeading: '',
            isSearchEnabled: false,
            searchPlaceHolder: '',
            emptyMessage: 'No account found',
            globalFilterFields: [],
            hasCheckbox: false,
            hasDetailsButton: true,
            isLazyLoadingEnabled: false,
            isPaginationEnabled: false,
            hasFilters: false,
            isExportEnabled: false,
            hasActions: false
        };
    }

    onAction(action: TableAction): void {
        if (this.actionListener) {
            this.actionListener(action);
        }
    }

    onDataFiltered(): void {
    }
}
